import _extends from 'babel-runtime/helpers/extends';
import axios from 'axios';
import adapter from 'axios/lib/adapters/http';
var saleStrategy = 'PrePaid';
import regions from './EcsRegion';
import getProperty from '@ali/get-value';

function getUrl(regionId, path) {
  var suffix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'jsonp';

  return 'https://' + getRegionHost(regionId) + path + '.' + suffix;
}
var getRegionHost = function getRegionHost(regionId) {
  return getProperty(regions, regionId + '.domain') || 'ecs-buy.aliyun.com';
};

var urlMap = {
  regionId: function regionId() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var suffix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'json';

    return {
      url: getUrl('', '/api/v2/region/describeRegions', suffix),
      data: _extends({}, data, {
        saleStrategy: saleStrategy
      })
    };
  },
  imageId: function imageId() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var suffix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'json';

    return {
      url: getUrl(data.regionId, '/api/ecsImage/describeImages', suffix),
      data: {
        regionId: data.regionId,
        instanceType: data.instanceType,
        imageOwnerAlias: 'system',
        isSupportIoOptimized: 'True',
        pageNumber: 1,
        pageSize: 100
      }
    };
  }
};

export default function getConstraints(_ref) {
  var commodityCode = _ref.commodityCode,
      specCode = _ref.specCode,
      _ref$anonymous = _ref.anonymous,
      anonymous = _ref$anonymous === undefined ? true : _ref$anonymous,
      fieldValues = _ref.fieldValues,
      targetFieldCode = _ref.targetFieldCode;

  var isTest = process.env.DN_CMD == 'test';
  var isUserInnerAccount = anonymous;
  var suffix = 'jsonp';
  if (isUserInnerAccount) {
    suffix = 'json';
  }
  var targetParamsFn = urlMap[targetFieldCode];
  if (!targetParamsFn) {
    return [];
  }
  var targetParams = targetParamsFn(fieldValues, suffix);
  var options = {
    method: 'get',
    url: targetParams.url,
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json'
    },
    params: targetParams.data
  };
  if (isTest) {
    options.adapter = adapter;
  }
  return axios(options).then(function (response) {
    if (response.status >= 200 && response.status < 300) {
      if (response.data.code = '200') {
        var _ref2;

        return _ref2 = {}, _ref2['' + targetFieldCode] = response.data.data, _ref2;
      }
    }
    var error = new Error(response.statusText);
    error.response = response;
    throw error;
  });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ali/common-cpq-constraint/es/ecs/getOptions.js
// module id = 142
// module chunks = 0